import React, { createContext, useContext, useState, useEffect } from 'react'
import { useConfig, useEvent } from '~components'

const CurrencyContext = createContext()

export const useCurrency = () => {
  const context = useContext(CurrencyContext)
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider')
  }
  return context
}

export const CurrencyProvider = ({ children }) => {
  const [{ configs, loading }] = useConfig()
  const [events] = useEvent()

  const defaultCurrency = configs?.stripe_currency?.value || 'USD'

  const [currency, setCurrency] = useState(defaultCurrency)

  const currencies = configs?.ecocash_currencies?.value
    ? configs.ecocash_currencies.value.split('|')
    : []

  const hasEcocashConfig = configs?.ecocash_currencies?.value && configs?.ecocash_exchange_rate?.value

  useEffect(() => {
    if (loading) return
    const savedCurrency = localStorage.getItem('currency')

    if (!hasEcocashConfig) {
      if (savedCurrency) {
        localStorage.removeItem('currency')
      }
      setCurrency(defaultCurrency)
      return
    }

    if (savedCurrency && currencies.includes(savedCurrency)) {
      setCurrency(savedCurrency)
    } else if ((savedCurrency && (!currencies.includes(savedCurrency) || currencies.length === 1)) || (!savedCurrency && currencies.length === 1)) {
      setCurrency(currencies[0])
      localStorage.setItem('currency', currencies[0])
      events.emit('currencyChanged', currencies[0])
    } else if (defaultCurrency) {
      setCurrency(defaultCurrency)
    }
  }, [defaultCurrency, currencies, loading])

  const changeCurrency = (newCurrency) => {
    if (hasEcocashConfig && currencies.includes(newCurrency)) {
      setCurrency(newCurrency)
      localStorage.setItem('currency', newCurrency)
      events.emit('currencyChanged', newCurrency)
    }
  }

  const value = {
    currency,
    currencies,
    changeCurrency,
    hasEcocashConfig
  }

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  )
}

export default CurrencyContext
